import React from 'react';
import { refillRequestPageTypes } from '../../../../config/app.config';
import {
  ClientPageWrapper,
  DefaultWrapper,
} from '../../Common/PageWithTableWrapper';

const refillClassName = 'refill-requests-container';
const profileRefillClassName =
  'refill-requests-container refill-requests-container--profile';

export const refillComponentsWrapperMap = {
  [refillRequestPageTypes.default]: (props) => (
    <DefaultWrapper className={refillClassName} {...props} />
  ),
  [refillRequestPageTypes.clientPage]: (props) => (
    <ClientPageWrapper className={profileRefillClassName} {...props} />
  ),
};
